import EditCurationAssigneeModal from './EditCurationAssigneeModal.container'
export default EditCurationAssigneeModal
